module.exports = __webpack_public_path__ + "ath_game_web/img/4.4.08a9c389.png";